import React from 'react';
import { Box } from '@mui/material';

// 1. Import your new GIF
import animationGif from './assets/santa-snowman.gif';

function CornerAnimation() {
  return (
    <Box
      component="img"
      src={animationGif}
      alt="Santa building a snowman animation"
      sx={{
        position: 'fixed', // This sticks it to the browser window
        bottom: 0,         // Puts it at the bottom
        left: 0,           // Puts it in the left corner
        // You can change 'left: 0' to 'right: 0' for the right corner
        
        width: '150px',    // Set a good size
        height: 'auto',
        zIndex: 1000,      // Make sure it's on top of the page (but below modals)
        
        // --- This is important! ---
        // Hide the animation on small mobile screens so it doesn't
        // cover up important content.
        display: { xs: 'none', md: 'block' } 
      }}
    />
  );
}

export default CornerAnimation;